import { lookupSite as lookupSiteApi } from '../../services';

export const lookupSite = async (type, thirdpartyId, query) => {
  try {
    const data = await lookupSiteApi(type, thirdpartyId, query);
    return data;
  } catch (error) {
    console.error('Unable to lookup site:', error);
    throw new Error('Unable to lookup site', { cause: error });
  }
};

export const getModelVersion = (model, activeSite) => {
  if (activeSite.version) return activeSite.version;

  const completedVersion = model.versions
    .toSorted((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .find((v) => v.status === 'COMPLETED');

  return completedVersion.id;
};
